import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 43,
	height: 43,
	viewBox: "0 0 43 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2241_4727)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M21.1879 31.9297C21.0671 31.9297 20.9513 31.9095 20.8405 31.8693C20.7399 31.829 20.6341 31.7484 20.5234 31.6276L15.192 26.417C15.0208 26.2459 14.9352 26.0495 14.9352 25.828C14.9352 25.5864 15.0107 25.39 15.1618 25.239C15.3229 25.0779 15.5243 24.9973 15.7659 24.9973C16.0277 24.9973 16.2391 25.093 16.4002 25.2843L18.9678 27.9576L20.3421 29.347L20.2666 27.142V7.40777C20.2666 7.16612 20.3572 6.95468 20.5385 6.77344C20.7197 6.59221 20.9362 6.50159 21.1879 6.50159C21.4396 6.50159 21.6561 6.59221 21.8374 6.77344C22.0186 6.95468 22.1092 7.16612 22.1092 7.40777V27.142L22.0488 29.347L23.393 27.9576L25.9605 25.2843C26.1317 25.093 26.3431 24.9973 26.5948 24.9973C26.8365 24.9973 27.0379 25.0779 27.199 25.239C27.3601 25.39 27.4406 25.5864 27.4406 25.828C27.4406 26.0495 27.35 26.2459 27.1688 26.417L21.8525 31.6276C21.7417 31.7484 21.6309 31.829 21.5202 31.8693C21.4195 31.9095 21.3087 31.9297 21.1879 31.9297Z",
				fill: "url(#paint0_linear_2241_4727)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M35.7668 30.262C35.7668 33.1157 29.2396 35.4292 21.1879 35.4292C13.1362 35.4292 6.60904 33.1157 6.60904 30.262",
				stroke: "#4AADFF",
				strokeWidth: 1.75,
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.3774 14.6346C12.8939 14.5128 13.4872 14.5141 14.0159 14.8433L14.0166 14.8421C14.0175 14.8427 14.0182 14.844 14.0192 14.8445C14.0201 14.8451 14.0215 14.8452 14.0225 14.8458L14.0217 14.8469C14.5416 15.171 14.8063 15.6895 14.9271 16.2017L15.998 20.7442C16.119 21.2575 16.1171 21.8475 15.787 22.3732L15.7858 22.3724C15.4581 22.8979 14.929 23.1604 14.4158 23.2814L7.92674 24.8112C7.41377 24.9321 6.82541 24.932 6.29883 24.609L6.2981 24.6102C6.29712 24.6096 6.29651 24.6084 6.29553 24.6078C6.29462 24.6072 6.29313 24.6071 6.29223 24.6065L6.29296 24.6054C5.76686 24.2822 5.50231 23.7584 5.38175 23.2469L4.31087 18.7045C4.1903 18.1929 4.19116 17.6039 4.51846 17.0783C4.51907 17.0773 4.51908 17.076 4.51969 17.075C4.52028 17.074 4.52033 17.0726 4.52092 17.0717L4.52209 17.0724C4.84893 16.5483 5.37539 16.2853 5.88828 16.1644L12.3774 14.6346ZM10.8535 21.5938L13.2687 21.0244L11.8294 20.2219L10.8535 21.5938ZM8.38312 22.1762L8.56847 22.1325L8.45773 22.0713L8.38312 22.1762ZM8.30321 19.2964L8.28193 19.3636C8.28401 19.3638 8.28613 19.365 8.28831 19.3651C8.29459 19.3653 8.29997 19.3648 8.30419 19.3644C8.30797 19.364 8.31068 19.3638 8.31107 19.3638C8.30931 19.3642 8.31498 19.3627 8.32465 19.3575C8.33461 19.3522 8.34279 19.3463 8.34712 19.3422L8.30321 19.2964ZM8.31176 19.2944L8.35266 19.3359L8.35847 19.3265C8.36 19.3217 8.35931 19.3153 8.36036 19.309L8.31176 19.2944ZM8.22975 19.3338L8.28039 19.2847L8.21977 19.2659C8.218 19.2716 8.21548 19.2817 8.21514 19.2931C8.2149 19.301 8.21635 19.3061 8.2166 19.3078L8.22348 19.3242C8.2253 19.3276 8.22777 19.3307 8.22975 19.3338ZM8.28911 19.2877L8.23417 19.3397L8.24441 19.3534L8.2538 19.3592C8.25885 19.3608 8.26649 19.3612 8.27461 19.3623L8.29337 19.3057L8.29315 19.3048L8.29784 19.2906L8.29549 19.2892L8.28911 19.2877ZM8.34238 19.237L8.31359 19.2638L8.30667 19.2855L8.36187 19.3026C8.36231 19.2989 8.36403 19.295 8.36416 19.291L8.36392 19.273L8.35771 19.2594C8.35231 19.2494 8.3465 19.2413 8.34238 19.237ZM8.29727 19.2797L8.29985 19.2821L8.30303 19.2743L8.29727 19.2797ZM8.22781 19.2489L8.222 19.2583L8.28592 19.2784L8.2448 19.2359L8.22781 19.2489ZM8.277 19.2193C8.27664 19.2194 8.27415 19.2204 8.27058 19.2218C8.26663 19.2233 8.26156 19.2252 8.25604 19.2282C8.25424 19.2292 8.25247 19.2305 8.25078 19.2315L8.2919 19.274L8.30727 19.2583L8.31911 19.2234C8.31342 19.2216 8.30334 19.2191 8.29193 19.2188C8.28101 19.2185 8.27525 19.2197 8.277 19.2193ZM8.31879 19.2476L8.33606 19.2314L8.32666 19.2256L8.31879 19.2476Z",
				fill: "url(#paint1_linear_2241_4727)",
				stroke: "#0A161F",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.07011 12.3299C8.70354 12.2771 8.43957 12.1526 8.2782 11.9563C8.1165 11.7622 8.05942 11.5002 8.10695 11.1703L8.71445 6.95317C8.76231 6.62093 8.89118 6.38457 9.10108 6.24407C9.3113 6.10127 9.59969 6.05628 9.96626 6.10909L16.5683 7.06014C16.9374 7.11331 17.2024 7.2392 17.3635 7.43781C17.5248 7.63413 17.5819 7.89612 17.5347 8.22378L16.9272 12.4409C16.8797 12.7708 16.751 13.0061 16.5411 13.1466C16.3309 13.2894 16.0412 13.3342 15.6721 13.281L9.07011 12.3299ZM11.8994 10.9694L14.2707 10.0936C14.3497 10.0605 14.3933 10.0072 14.4014 9.93349C14.4123 9.85788 14.3855 9.79439 14.3212 9.74302L12.2945 8.22669C12.2252 8.17459 12.1496 8.15669 12.0678 8.17297C11.9885 8.18962 11.9434 8.23574 11.9325 8.31136L11.5765 10.7825C11.5656 10.8581 11.5945 10.9161 11.663 10.9563C11.734 10.997 11.8128 11.0013 11.8994 10.9694Z",
				fill: "url(#paint2_linear_2241_4727)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M31.487 10.6848L32.1363 10.8089L32.1046 10.9749C32.1996 11.0387 32.2819 11.1096 32.3536 11.1806L32.3547 11.1798C32.3585 11.1834 32.3619 11.1872 32.3656 11.1908C32.3681 11.1933 32.3706 11.1957 32.3731 11.1982L32.372 11.199C32.4922 11.3182 32.5953 11.4489 32.6834 11.5827L32.6845 11.5819L34.7477 14.6598L34.7538 14.6699C34.8321 14.7898 34.9046 14.9176 34.9654 15.0504L34.9663 15.0506C34.9681 15.0541 34.9695 15.0579 34.9712 15.0615C34.9759 15.0718 34.9817 15.0817 34.9862 15.0922L34.9841 15.0928C35.0288 15.191 35.0658 15.2977 35.0901 15.4123L35.257 15.4442L35.1086 16.2202L35.0874 16.924L34.9781 16.9031L34.2836 20.5356C34.1731 21.1137 33.9087 21.6938 33.3623 22.0676L33.3631 22.0687C32.8145 22.4467 32.175 22.4788 31.5967 22.3683L26.9379 21.4776C26.3585 21.3669 25.7784 21.1011 25.4057 20.5524C25.0317 20.0016 25.0055 19.3591 25.1157 18.7828L26.4004 12.0627C26.5107 11.4862 26.7725 10.9049 27.3169 10.5298C27.8663 10.1514 28.5061 10.1149 29.089 10.2263L30.6774 10.53L30.7097 10.3612L31.487 10.6848Z",
				fill: "url(#paint3_linear_2241_4727)",
				stroke: "#0A161F",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_2241_4727",
			x1: 21.1969,
			y1: 12.8533,
			x2: 21.1969,
			y2: 29.8533,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5FC7FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4AADFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_2241_4727",
			x1: 9.79985,
			y1: 17.7115,
			x2: 10.7822,
			y2: 21.8784,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5FC7FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4AADFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_2241_4727",
			x1: 13.2019,
			y1: 7.86968,
			x2: 12.6446,
			y2: 11.7383,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5FC7FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4AADFF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_2241_4727",
			x1: 30.9627,
			y1: 13.5651,
			x2: 29.8585,
			y2: 19.3405,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#5FC7FE" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#4AADFF"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_2241_4727",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 31.783,
				height: 31.7812,
				fill: "white",
				transform: "translate(5.29688 5.29688)"
			})
		})
	] })]
});
export default SvgDownload;
